// extracted by mini-css-extract-plugin
module.exports =  {"tagFilter":"tagFilter_rHzLcUJv","shadowRight":"shadowRight_clk3YAf7","shadowLeft":"shadowLeft_YxvA3hT3","shadowBoth":"shadowBoth_FR764OiJ"};